import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getCustomerOrderdetails } from "redux/actions";
import { getLocalStorageValue } from "config/helper";
import "./order-theme2.scss";
import { modifyOrder } from 'services/order';
import { useApiDefaults } from 'hooks/useApiDefaults';
import Pagination from "components/Common/Pagination";
import { getAvailableAmount } from 'config/constant';

const MyOrderTheme2 = () => {
  const dispatch = useDispatch();
  const clientId = getLocalStorageValue("RSAclient-id");
  const userToken = getLocalStorageValue("user-token");
  const memberNumber = getLocalStorageValue("member-number");
  const { currentStoreID, storeListData } = useSelector(({ store }) => store);
  const storeId = currentStoreID || getLocalStorageValue("selected-store-id");
  const currentStoreName = storeListData?.find(s => +s.ClientStoreId === +storeId)?.ClientStoreName;
  const {
    orderlistData,
    OrderStatusList,
    OrderDetailsListLimit,
    OrderDetailsTotalRecord,
    orderlistDataLoading,
  } = useSelector(({ customer }) => customer);

  const isUserLoggedIn = useSelector(({ user }) => user.isUserLoggedIn);

  const [page, setPage] = useState(1);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const navigate = useNavigate();
  const apiDefaults = useApiDefaults()
  
  const [modifyOrderId, setModifyOrderId] = useState(null);
  const [callingModifyOrder, setCallingModifyOrder] = useState(false);
  const [modifyOrderError, setModifyOrderError] = useState(null);
  const orderStoreName = orderlistData?.find(o => o.order_id === modifyOrderId)?.ClientStoreName
  const modifyOrderStoreChangeRequired = modifyOrderId && orderStoreName !== currentStoreName

  const handleModifyOrder = async () => {
    if (callingModifyOrder) {
      return;
    }

    setCallingModifyOrder(true);
    setModifyOrderError(null);

    const {error} = await modifyOrder({
      ...apiDefaults,
      order_id: modifyOrderId,
    });
    setCallingModifyOrder(false);

    if (error) {
      setModifyOrderError(error);
    } else {
      setModifyOrderId(modifyOrderId);
      navigate("/your-cart");
    }
  };

  const totalPages = Math.ceil(
    +OrderDetailsTotalRecord / +OrderDetailsListLimit
  );


  const handleSetPage = (data) => {
    dispatch(getCustomerOrderdetails(data));
    scrollToTop();
    setPage(data);
};


  useEffect(() => {
    const body = {
      RSAClientId: clientId,
      ClientStoreId: storeId,
      PageNo: page,
      AppName: isUserLoggedIn ? "shop" : "",
      member_number: isUserLoggedIn ? memberNumber : "",
      user_token: isUserLoggedIn ? userToken : "",
      Version: isUserLoggedIn ? "1" : "",
      DeviceType: isUserLoggedIn ? "web" : "",
    };
    dispatch(getCustomerOrderdetails(body));
  }, [
    dispatch,
    clientId,
    memberNumber,
    userToken,
    storeId,
    isUserLoggedIn,
    page,
  ]);

  const [isOrderModalVisible, setIsOrderModalVisible] = useState(false);
  const openorderModal = () => {
    setIsOrderModalVisible(true);
  };

  const closeorderModal = () => {
    setIsOrderModalVisible(false);
    setModifyOrderId(null);
    setCallingModifyOrder(false);
    setModifyOrderError(null);
  };

  if (!orderlistData?.length) {
    return (
      <Layout>
        <div className="no-order-message">
          {" "}
          {orderlistDataLoading ? "Please wait..." : "No Orders yet!"}
        </div>
      </Layout>
    )
  }

  function ModifyOrderModal() {
    if (!isOrderModalVisible) {
      return null
    }

    if (modifyOrderStoreChangeRequired) {
      return (
        <ModifyOrderLayout>
          <p>
            You are in the <strong>{currentStoreName}</strong> store while your order is in the{" "}
            <strong>{orderStoreName}</strong> store. Please change your store to proceed.
          </p>
          <button className="close-btn" onClick={closeorderModal}>
            &times;
          </button>
          <button className="submit-btn" onClick={closeorderModal}>
            Okay
          </button>
        </ModifyOrderLayout>
      )
    }

    return (
      <ModifyOrderLayout>
        <h2>Please Review Before Continuing</h2>
        <p>
          You order will be moved to cart and allow you to add/remove items and
          complete checkout.
        </p>
        <p>
          • You&apos;ll have <strong>10 minutes</strong> to complete the changes
        </p>
        <p>
          • Your current cart will be <strong>replaced</strong> with the order
          items
        </p>
        <p className="continue-text">Click modify to continue.</p>
        <button className="close-btn" onClick={closeorderModal}>
          &times;
        </button>
        <button
          className="submit-btn"
          onClick={handleModifyOrder}
          disabled={callingModifyOrder}
        >
          {callingModifyOrder ? "Modifying..." : "Modify"}
        </button>
        {modifyOrderError ? (
          <span className="error-text">{modifyOrderError}</span>
        ) : null}
      </ModifyOrderLayout>
    )
  }
  
  return (
    <Layout>
      <div className="order-section-wrapper">
        {orderlistData.map((order, index) => {
          const orderAmount = getAvailableAmount(order?.transaction_total_amount, order?.total_amount)
          return (
            <div className="order-section-items" key={index}>
              <div className="order-item-main">
              <div className="order-items-main-wrap">
                    <div className="order-items">
                      <div className="order-title">
                        {order?.order_item_list
                          ?.map((orderItem) => orderItem.name?.substr(0, 15))
                          .join(", ")}
                      </div>
                      <div className="order-product-image">
                        {order?.order_item_list?.map((orderItem) => (
                          <div className="order-image">
                            <img src={orderItem?.image} alt="product_image" />
                          </div>
                        ))}
                      </div>
                      <div className="order-number-id">
                        <div className="order-num-title">
                          Store : <span>{order?.ClientStoreName}</span>
                        </div>
                      </div>
                      <div className="order-number-id">
                        <div className="order-num-title">
                          Order Number : <span>{order.order_number}</span>
                        </div>
                      </div>
                      <div className="order-product-month">
                        {dateFormat(
                          order.order_placed_on.split(" ")[0],
                          "MM-dd-yyyy"
                        )}
                        {/* <span>{order?.order_item_list?.length} Products</span> */}
                      </div>
                    </div>
                    
                    <div className="order-price-section">
                      {order?.allow_edit_order === "1" ? (
                      <span
                        onClick={() => {
                          setModifyOrderId(order.order_id)
                          openorderModal()
                        }}
                      >
                        modify order
                      </span>
                    ) : null}

                      <ModifyOrderModal />

                      <Link
                        to={`/order-details/${order.order_id}`}
                        key={order.order_id}
                        state={{ OrderStatusList: OrderStatusList }}
                      >
                        <span>View Order</span>
                      </Link>
                      <span className="price">{`$${orderAmount}`}</span>
                    </div>

                  </div>
                {/* <div className="pickup-btn-wrap">
                <button className="pickup-btn" onClick={openModal}>
                    <div className="pickup-ico">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" strokeWidth="1.5" color="currentColor"><path d="M19.5 17.5a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0m-10 0a2.5 2.5 0 1 1-5 0a2.5 2.5 0 0 1 5 0" /><path d="M14.5 17.5h-5M2 4h10c1.414 0 2.121 0 2.56.44C15 4.878 15 5.585 15 7v8.5m.5-9h1.801c.83 0 1.245 0 1.589.195c.344.194.557.55.984 1.262l1.699 2.83c.212.354.318.532.373.728c.054.197.054.403.054.816V15c0 .935 0 1.402-.201 1.75a1.5 1.5 0 0 1-.549.549c-.348.201-.815.201-1.75.201M2 13v2c0 .935 0 1.402.201 1.75a1.5 1.5 0 0 0 .549.549c.348.201.815.201 1.75.201M2 7h6m-6 3h4" /></g></svg>
                  </div>
                    Check-In For Pickup
                </button>
                {isModalVisible && (
                        <div className='modal-overlay'>
                            <div className='modal-content'>
                                <button className='close-btn' onClick={closeModal}>
                                    &times;
                                </button>
                                <div className='modal-body'>
                                    <div className="popup-container">
                                        <div className="input-group model-group">
                                            <div className="group-label">
                                                <label>Make</label>
                                                <input type="text" placeholder="Enter make" />
                                            </div>
                                            <div className="group-label">
                                                <label>Model</label>
                                                <input type="text" placeholder="Enter model" />
                                            </div>
                                        </div>
                                        <div className="input-group">
                                            <label>Enter the curbside pickup location No# (Optional):</label>
                                            <input type="text" />
                                        </div>
                                        <div className="input-group">
                                            <label>Enter The Curbside Pickup License Plate# (Optional):</label>
                                            <input type="text" />
                                        </div>
                                        <h3>Tell us about your vehicle</h3>
                                        <div className="picup-items">
                                            <label>vahicle type:</label>
                                            <div
                                                className="pickup-item-wrap items"
                                                onMouseDown={handleMouseDown}
                                                onMouseLeave={handleMouseLeave}
                                                onMouseUp={handleMouseUp}
                                                onMouseMove={handleMouseMove}>
                                                <div className={`pickup-item-with-checkbox ${isChecked ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="1"
                                                        className="custom-checkbox"
                                                        checked={isChecked}
                                                        onChange={() => setIsChecked(!isChecked)}
                                                    />
                                                    <label htmlFor="1" className="custom-label">
                                                        <img src={CarImage} className="img-fluid" alt="Icon" />
                                                        <label for="1"><span>suv</span></label>
                                                    </label>
                                                </div>
                                                <div className={`pickup-item-with-checkbox ${isChecked ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="2"
                                                        className="custom-checkbox"
                                                        checked={isChecked}
                                                        onChange={() => setIsChecked(!isChecked)}
                                                    />
                                                    <label htmlFor="2" className="custom-label">
                                                        <img src={CarImage} className="img-fluid" alt="Icon" />
                                                        <label for="2"><span>Sedan</span></label>
                                                    </label>
                                                </div>
                                                <div className={`pickup-item-with-checkbox ${isChecked ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="3"
                                                        className="custom-checkbox"
                                                        checked={isChecked}
                                                        onChange={() => setIsChecked(!isChecked)}
                                                    />
                                                    <label htmlFor="3" className="custom-label">
                                                        <img src={CarImage} className="img-fluid" alt="Icon" />
                                                        <label for="3"><span>Hatchback</span></label>
                                                    </label>
                                                </div>
                                                <div className={`pickup-item-with-checkbox ${isChecked ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="3"
                                                        className="custom-checkbox"
                                                        checked={isChecked}
                                                        onChange={() => setIsChecked(!isChecked)}
                                                    />
                                                    <label htmlFor="3" className="custom-label">
                                                        <img src={CarImage} className="img-fluid" alt="Icon" />
                                                        <label for="3"><span>Convertible</span></label>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="color-items">
                                            <label>vahicle color:</label>
                                            <div
                                                className="color-item-wrap items"
                                                onMouseDown={handleMouseDown}
                                                onMouseLeave={handleMouseLeave}
                                                onMouseUp={handleMouseUp}
                                                onMouseMove={handleMouseMove}>
                                                <div className={`color-item-with-checkbox ${isChecked1 ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="color1"
                                                        className="custom-checkbox"
                                                        checked={isChecked1}
                                                        onChange={() => setIsChecked1(!isChecked1)}
                                                    />
                                                    <label htmlFor="color1" className="custom-label">
                                                        <span className="color-box" style={{ backgroundColor: "#ff000" }}></span>
                                                        <span>Red</span>
                                                    </label>
                                                </div>
                                                <div className={`color-item-with-checkbox ${isChecked1 ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="color2"
                                                        className="custom-checkbox"
                                                        checked={isChecked1}
                                                        onChange={() => setIsChecked1(!isChecked1)}
                                                    />
                                                    <label htmlFor="color2" className="custom-label">
                                                        <span className="color-box" style={{ backgroundColor: "#191970" }}></span>
                                                        <span>Blue</span>
                                                    </label>
                                                </div>
                                                <div className={`color-item-with-checkbox ${isChecked1 ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="color3"
                                                        className="custom-checkbox"
                                                        checked={isChecked1}
                                                        onChange={() => setIsChecked1(!isChecked1)}
                                                    />
                                                    <label htmlFor="color3" className="custom-label">
                                                        <span className="color-box" style={{ backgroundColor: "#F88379" }}></span>
                                                        <span>Pink</span>
                                                    </label>
                                                </div>
                                                <div className={`color-item-with-checkbox ${isChecked1 ? "checked" : ""}`}>
                                                    <input
                                                        type="checkbox"
                                                        id="color4"
                                                        className="custom-checkbox"
                                                        checked={isChecked1}
                                                        onChange={() => setIsChecked1(!isChecked1)}
                                                    />
                                                    <label htmlFor="color4" className="custom-label">
                                                        <span className="color-box" style={{ backgroundColor: "#00827F" }}></span>
                                                        <span>Green</span>
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                        <button className="submit-btn">Submit</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
              </div> */}
              </div>
            </div>
          );
        })}

{orderlistData.length ? (
        <Pagination
          pages={totalPages}
          current={page}
          onClick={handleSetPage}
        />
      ) : (
        ""
      )}
      </div>
    </Layout>
  );
};

function Layout({children}) {
  return (
    <div className="order-section-theme2">
      <div className="order-page-title">
        <h1>My Orders</h1>
      </div>
      <div className="order-section-main-wrapper">{children}</div>
    </div>
  )
}

function dateFormat(inputDate, format) {
  const date = new Date(inputDate);

  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  format = format.replace("MM", month.toString().padStart(2, "0"));

  if (format.indexOf("yyyy") > -1) {
    format = format.replace("yyyy", year.toString());
  } else if (format.indexOf("yy") > -1) {
    format = format.replace("yy", year.toString().substr(2, 2));
  }
  format = format.replace("dd", day.toString().padStart(2, "0"));

  return format;
}

function ModifyOrderLayout({children}) {
  return (
    <div className="order-modal-overlay">
      <div className="order-modal-content">{children}</div>
    </div>
  )
}

export default MyOrderTheme2;
